import { CheckoutEvent } from './checkout-event.interface';
import { CheckoutStatus } from './checkout-status.type';
import { CheckoutSuccessfulContract } from './checkout-successful-contract.interface';

export interface CheckoutEventSuccess extends CheckoutEvent {
  transactionId: string;
  status: CheckoutStatus;
  contracts: CheckoutSuccessfulContract[];
}
